import { JsonSchemaValidator } from "@common/json-schema-validator";

export const brandBgDataFile = {
  [JsonSchemaValidator.isFile]: true
};
